import { Button } from "./button";

export class ButtonGroup extends Button {
	constructor() {
		super();

		this.type = this.getAttribute("type") ?? "single";
		this.hiddenName = this.getAttribute("hidden-name");
		this.size = this.getAttribute("size");
		this.spacing = this.getAttribute("spacing") ?? "";
		this.variation = this.getAttribute("variation");
		this.label = this.getAttribute("label") ?? "";
		this.helperText = this.getAttribute("helper-text") ?? "";

		if (this.closest("form") && !this.hiddenName) {
			this.hiddenName = this.id;
		}
	}

	parsedCallback() {
		const wrapper = document.createElementWithContents("div", document.createElementWithContents("ul", [...this.children ?? []].map(x => document.createElementWithContents("li", x))), { className: "button-group__container" });

		const buttons = wrapper.querySelectorAll("chip-button, chip-dropdownbutton, chip-splitbutton");

		if (buttons.length < 6) {
			wrapper.querySelector("ul").setAttribute("columns", buttons.length);
		}

		buttons.forEach(button => {
			if (!button.getAttribute("size") && this.size) { button.size = this.size; }
			if (!button.getAttribute("buttonStyle") && this.buttonStyle) { button.buttonStyle = this.buttonStyle; }
			if (!button.getAttribute("orientation") && this.orientation) { button.orientation = this.orientation; }

			if (this.variation) { button.variation = this.variation; }
			if (this.disabled) { button.disabled = this.disabled; }

			button.buttonClass = button.buttonClass + ` ${this.buttonClass}`.trim();

			switch (button.nodeName) {
				case "CHIP-BUTTON":
					button.addEventListener("click", ev => this.#HandleButtonClick(ev.target));
					break;
				case "CHIP-DROPDOWNBUTTON":
					button.querySelector("chip-dropdown").onselectionchange = () => this.#HandleButtonClick(button);
					break;
				case "CHIP-SPLITBUTTON":
					button.addEventListener("click", ev => this.#HandleButtonClick(ev.target));
					button.querySelectorAll("chip-dropdownitem").forEach(item => item.addEventListener("click", ev => this.#HandleButtonClick(ev.target)));
					break;
			}
		});

		if (this.hiddenName) {
			wrapper.appendChild(document.createElementWithContents("input", null, {
				type: "hidden",
				value: this.value,
				name: this.hiddenName
			}));
		}

		if (this.label) {
			wrapper.prepend(document.createElementWithContents("div", this.label, { className: "input-field__label" }));
		}

		this.appendChild(wrapper);

		if (this.helperText) {
			wrapper.appendChild(document.createElementWithContents("div", this.helperText, { className: "input-field__helper-text" }));
		}

		this.#SelectValue(this.value);
	}

	#SelectButton(button) {
		if (!button) { return; }

		if (this.type === "single") {
			this.querySelectorAll("chip-button, chip-dropdownbutton, chip-splitbutton").forEach(btn => {
				btn.active = btn === button;
			});
		} else {
			button.active = true;
		}

		this.#UpdateHiddenInput();
	}

	#SelectValue(value) {
		for (const target of [...this.querySelectorAll("chip-button, chip-splitbutton, chip-dropdownbutton")].filter(x => value?.split("|").includes(x.value?.toString()))) {
			this.#SelectButton(target);
		}
	}

	#UpdateHiddenInput() {
		const hiddenInput = this.querySelector("input[type='hidden']");

		if (hiddenInput) {
			hiddenInput.value = [...this.querySelectorAll("chip-button[active], chip-dropdownbutton[active], chip-splitbutton[active]")].
				map(x => x.value).join("|");
		}
	}

	#HandleButtonClick(target) {
		const closestButton = target.closest("chip-button, chip-splitbutton, chip-dropdownbutton");

		let elements = (this.type === "single" ? [] : [...this.querySelectorAll("chip-button[active], chip-dropdownbutton[active], chip-splitbutton[active]")])
			.concat(closestButton);

		if (closestButton.active && this.type !== "single") {
			elements = elements.filter(x => x !== closestButton);

			closestButton.active = false;
			this.#UpdateHiddenInput();
		}

		const oldValue = this.value;
		this.value = elements.map(x => x.value).join("|");

		if (oldValue !== this.value) {
			this.raiseEvent("change");
		}
	}

	attributeChanged(name, _, newValue) {
		if (name === "value") {
			this.#SelectValue(newValue);
		}
	}
}